import { render, staticRenderFns } from "./AppelDeFondsItem.vue?vue&type=template&id=ad0c27ec&scoped=true&"
import script from "./AppelDeFondsItem.vue?vue&type=script&lang=js&"
export * from "./AppelDeFondsItem.vue?vue&type=script&lang=js&"
import style0 from "./AppelDeFondsItem.vue?vue&type=style&index=0&id=ad0c27ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0c27ec",
  null
  
)

export default component.exports